module.exports = __webpack_public_path__ + "static/flags/PA-0d1d92c0b46b248a46b6ab8e9e2be357.gif";